import { Link } from 'react-router-dom';
import { allCategories, getArticlesByCategory } from '@/utils/news';

export default function CategoryEntry() {
  return (
    <section>
      <div className="mb-4 flex items-center justify-between">
        <h2 className="font-heading text-lg font-bold text-foreground-900 md:text-xl">分类快捷入口</h2>
        <span className="text-xs text-foreground-400">三大板块 · 一键直达</span>
      </div>
      <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 sm:grid sm:grid-cols-3 sm:overflow-visible sm:pb-0">
        {allCategories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative h-40 w-72 shrink-0 snap-start overflow-hidden rounded-lg sm:w-auto"
          >
            <img
              src={cat.cover}
              alt={cat.name}
              title={`${cat.name}热点 - 热搜榜`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-primary-950/10"></div>
            <div className="absolute inset-0 flex flex-col justify-end p-4">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50 dark:text-foreground-950">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                <h3 className="font-heading text-lg font-bold text-background-50">{cat.name}</h3>
              </div>
              <p className="mt-1 line-clamp-1 text-xs text-background-200">{cat.description}</p>
              <span className="mt-1 text-xs text-accent-400">
                共 {getArticlesByCategory(cat.slug).length} 条资讯 →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}